<template>
  <v-card>
    <v-toolbar flat>
      <div>
        <v-toolbar-title class="text-h6 font-weight-regular">Last Service Spend</v-toolbar-title>
      </div>
    </v-toolbar>
      <v-container class="ma-0 mp-0">
        <v-form ref="lastServiceSpendForm" autocomplete="off">
          <v-card-text>
           <v-row no-gutters>
              <v-col cols="3">
                <p class="text-subtitle-1 font-weight-medium">Services Since Date:</p>
              </v-col>
           </v-row>

            <v-row no-gutters>
              <v-col cols="3" offset="1">
                <v-subheader>Last Service Date</v-subheader>
              </v-col>
              <v-col cols="3">
                <v-autocomplete
                  autocomplete="off"
                  v-model="lastServiceDateCol"
                  :items="csvColumnNames"
                >
                </v-autocomplete>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="3" offset="1">
                <v-subheader>Start Date / Mailer Date</v-subheader>
              </v-col>
              <v-col cols="3">
                <ymd-datepicker
                  v-model="startDate"
                  placeholder="Start Date"
                  required
                  :rules="vruleFieldRequired"
                  hint="*Required"
                  persistent-hint
                ></ymd-datepicker>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="3" offset="1">
                <v-subheader>End Date</v-subheader>
              </v-col>
              <v-col cols="3">
                <ymd-datepicker
                  v-model="endDate"
                  placeholder="End Date"
                  required
                  :rules="vruleFieldRequired"
                  hint="*Required"
                  persistent-hint
                ></ymd-datepicker>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="3" offset="1">
                <v-subheader>Return Matches Only</v-subheader>
              </v-col>
              <v-col cols="3">
                <v-checkbox
                  v-model="returnMatchesOnly"
                  label="Return Matches Only"
                ></v-checkbox>
              </v-col>
            </v-row>

          </v-card-text>
        </v-form>
      </v-container>
  </v-card>

</template>

<script>
import validationMixin from '@/validators/validations_mixin'
import YMDDatePicker from '@/components/inputs/YMDDatePicker'
import StepHelperMixin from './StepHelperMixin'
import { mapActions, mapGetters, mapState } from 'vuex'
import { path } from 'ramda'

export default {
  name: 'last-service-spend-roi',
  mixins: [validationMixin, StepHelperMixin],
  components: {
    [YMDDatePicker.name]: YMDDatePicker
  },
  data: function () {
    return {
      foo: 'bar'
    }
  },
  computed: {
    ...mapState('CsvMappingStore', ['csvColumnNames', 'workflowSteps', 'transforms']),
    componentName () {
      return this.$options.name
    },
    startDate: {
      get () {
        return path(['start_date'], this.mappingTransformData()(this.componentName))
      },
      set (val) {
        this.updateMappingTransformData({
          componentName: this.componentName,
          key: 'start_date',
          value: val
        })
        this.validateStep()
      }
    },
    endDate: {
      get () {
        return path(['end_date'], this.mappingTransformData()(this.componentName))
      },
      set (val) {
        this.updateMappingTransformData({
          componentName: this.componentName,
          key: 'end_date',
          value: val
        })
        this.validateStep()
      }
    },
    lastServiceDateCol: {
      get () {
        return path(['last_service_date_col'], this.mappingTransformData()(this.componentName))
      },
      set (val) {
        this.updateMappingTransformData({
          componentName: this.componentName,
          key: 'last_service_date_col',
          value: val
        })
        this.validateStep()
      }
    },
    returnMatchesOnly: {
      get () {
        return path(['only_return_matches'], this.mappingTransformData()(this.componentName))
      },
      set (val) {
        this.updateMappingTransformData({
          componentName: this.componentName,
          key: 'only_return_matches',
          value: val
        })
        this.validateStep()
      }
    }
  },
  methods: {
    ...mapActions('CsvMappingStore', ['updateMappingTransformData']),
    ...mapGetters('CsvMappingStore', ['mappingTransformData']),
    validateStep () {
      const hasVal = !!this.lastServiceDateCol && !!this.startDate && !!this.endDate
      if (typeof this.returnMatchesOnly !== 'undefined') {
        this.setStepIsValid(hasVal)
      } else {
        this.setStepIsValid(false)
      }
    }
  },
  mounted () {
    // needs to be initialized...
    this.returnMatchesOnly = false
  }
}
</script>
